export const getFullName = (fullName: string | undefined) => {
  if (fullName?.includes("@")) {
    return fullName
      .split(".")
      .map((name) => {
        name.charAt(0).toUpperCase();

        return name;
      })
      .join(" ")
      .replace("@ISW", "");
  }

  return typeof fullName === "string"
    ? fullName
        .split(" ")
        .map((name) => {
          name.charAt(0).toUpperCase();

          return name;
        })
        .join(" ")
        .replace("@ISW", "")
    : "";
};
